import { getProductDiscountPercent } from "../../../Routes/Marketplace/libs/productPricing";
import { getSizeFieldsForCategory } from "../../merchant/utils/categoryFormConfig";
import { parseSizeStock, sumSizeStock } from "../../../Routes/Marketplace/libs/productSizes";
import { getProductApprovalStatus } from "./productApprovalDisplay";

export const getAdminProductStock = (product) => {
  const sizeFields = getSizeFieldsForCategory(product?.category);
  if (sizeFields.length) return sumSizeStock(product, sizeFields);
  return Math.max(0, parseInt(product?.quantity, 10) || 0);
};

export const getAdminProductSizeEntries = (product) => {
  const sizeFields = getSizeFieldsForCategory(product?.category);
  if (!sizeFields.length) return [];
  return sizeFields
    .map(([field, label]) => ({ label, stock: parseSizeStock(product?.[field]) }))
    .filter((entry) => entry.stock > 0);
};

export const isAdminProductOnSale = (product) => getProductDiscountPercent(product) != null;

export const getAdminProductFilters = () => [
  { id: "all", label: "All" },
  { id: "pending", label: "Pending review" },
  { id: "approved", label: "Approved" },
  { id: "rejected", label: "Rejected" },
  { id: "hot", label: "Hot deals" },
  { id: "trending", label: "Trending" },
  { id: "today", label: "Today's deals" },
  { id: "on_sale", label: "On sale" },
  { id: "in_stock", label: "In stock" },
  { id: "out_of_stock", label: "Out of stock" },
];

export const filterAdminProducts = (products, search, filter) => {
  const term = search.trim().toLowerCase();
  return products.filter((product) => {
    const matchesSearch =
      !term ||
      (product.name || "").toLowerCase().includes(term) ||
      (product.category || "").toLowerCase().includes(term) ||
      (product.brand || "").toLowerCase().includes(term);

    if (!matchesSearch) return false;

    const stock = getAdminProductStock(product);
    const approvalStatus = getProductApprovalStatus(product);

    if (filter === "pending") return approvalStatus === "pending";
    if (filter === "approved") return approvalStatus === "approved";
    if (filter === "rejected") return approvalStatus === "rejected";
    if (filter === "hot") return product.isHotDeal;
    if (filter === "trending") return product.isTrending;
    if (filter === "today") return product.isTodaysDeal;
    if (filter === "on_sale") return isAdminProductOnSale(product);
    if (filter === "in_stock") return stock > 0;
    if (filter === "out_of_stock") return stock === 0;

    return true;
  });
};

export const getAdminProductStats = (products) => ({
  total: products.length,
  pending: products.filter((p) => getProductApprovalStatus(p) === "pending").length,
  approved: products.filter((p) => getProductApprovalStatus(p) === "approved").length,
  rejected: products.filter((p) => getProductApprovalStatus(p) === "rejected").length,
  hot: products.filter((p) => p.isHotDeal).length,
  trending: products.filter((p) => p.isTrending).length,
  today: products.filter((p) => p.isTodaysDeal).length,
  onSale: products.filter((p) => isAdminProductOnSale(p)).length,
  outOfStock: products.filter((p) => getAdminProductStock(p) === 0).length,
});
